export function events() {
    const upcomingButtonEl = document.querySelector(".events-list__buttons--upcoming");
    const completedButtonEl = document.querySelector(".events-list__buttons--completed");
    const upcomingEventsEl = document.querySelector(".events-list__items--upcoming");
    const completedEventsEl = document.querySelector(".events-list__items--completed");
    const activeClass = "active";
    const hiddenClass = "events-list__items--hidden";

    if (upcomingButtonEl) {
        upcomingButtonEl.addEventListener("click", () => {
            upcomingEventsEl.classList.remove(hiddenClass)
            completedEventsEl.classList.add(hiddenClass)
            upcomingButtonEl.classList.add(activeClass)
            completedButtonEl.classList.remove(activeClass)
        })
    }

    if (completedButtonEl) {
        completedButtonEl.addEventListener("click", () => {
            upcomingEventsEl.classList.add(hiddenClass)
            completedEventsEl.classList.remove(hiddenClass)
            upcomingButtonEl.classList.remove(activeClass)
            completedButtonEl.classList.add(activeClass)
        })
    }
}